import { useEffect, useState } from "react";
import { Usuario } from "../../types/usuario/Usuario";
import { useSnackbar } from "notistack";
import { useGetUsuariosQuery } from "../usuario/usuarioApiSlice";



type Props = {
    inputValue: string;
    handleSetLoad: (newValue: boolean) => void;
};




const useUsuarioFetch = (
    { inputValue,
        handleSetLoad
    }: Props) => {


    const [options, setOptions] = useState<Usuario[]>([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();



    if (handleSetLoad) { handleSetLoad(true); }
    const { data, isFetching, error } = useGetUsuariosQuery({search: inputValue});

    useEffect(() => {

        if (data) {
            setOptions(data as Usuario[]);
        }

        if (error) {
            let msgBox: string = ""
            if ('status' in error) {
                if (error.status == 'FETCH_ERROR') {
                    msgBox += 'Erro de conexão ao solicitar o serviço! Verifique sua internet. FETCH_ERROR '
                } else {
                    msgBox += 'Erro ao buscar os dados:  ' + (error.status)
                }
            } else {
                msgBox += 'Erro encontrado:' + error
            }
            enqueueSnackbar(msgBox, { variant: "error" });
        }

    }, [isFetching, error])

    if (handleSetLoad) { handleSetLoad(false); }

    return { options };
};


export default useUsuarioFetch;